// The page most in view: the highest visible ratio wins, ties to the earlier
// page. Null until any page is in view.
export const mostVisiblePage = (ratios: ReadonlyMap<number, number>) => {
  let best: number | null = null;
  let bestRatio = 0;
  for (const [page, ratio] of ratios) {
    if (ratio <= 0) continue;
    if (
      best === null ||
      ratio > bestRatio ||
      (ratio === bestRatio && page < best)
    ) {
      best = page;
      bestRatio = ratio;
    }
  }
  return best;
};
